<template>
  <div class="banner" v-if="isBanner">
    <img :src="bannerUrl !='' ? bannerUrl : banner"/>
  </div>
</template>
<script>
export default {
  name: 'banner',
  data () {
    return {
      banner: require('../assets/banner.png')
    }
  },
  props: {
    // 图片地址
    bannerUrl: {
      default: '',
      type: String
    },
    // 是否开启banner
    isBanner: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less">
  .banner{
    img{
      width:100%;
    }
  }
</style>
